import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';

export const MAPPED_CHANGE_REQUEST_STATUS = {
    [ChangeRequestStatus.NEW]: 'New',
    [ChangeRequestStatus.WAITING_REVIEW]: 'Waiting Review',
    [ChangeRequestStatus.REOPENED]: 'Reopened',
    [ChangeRequestStatus.REJECTED]: 'Rejected',
    [ChangeRequestStatus.APPROVED]: 'Approved',
    [ChangeRequestStatus.IN_REVIEW]: 'In Review',
    [ChangeRequestStatus.WAITING_APPROVE]: 'Waiting Approve',
};

export const NOT_EDIT_CHANGE_REQUEST_STATUSES = [
    ChangeRequestStatus.WAITING_REVIEW,
    ChangeRequestStatus.IN_REVIEW,
    ChangeRequestStatus.WAITING_APPROVE,
];

export const OPENED_CHANGE_REQUEST_STATUSES = [
    ChangeRequestStatus.NEW,
    ChangeRequestStatus.REOPENED,
    ChangeRequestStatus.WAITING_REVIEW,
    ChangeRequestStatus.IN_REVIEW,
    ChangeRequestStatus.WAITING_APPROVE,
];
